module.exports = __webpack_public_path__ + "img/Make-A-Move-LOGO.da3593b1.png";